// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"DeleteAddressSnackbar_snackbar__X3H1D","snackbarAppears":"DeleteAddressSnackbar_snackbarAppears__vNL2r"};